import {StripeClientOptions} from "../add-new";
declare let StripeCheckout:any;
RedNaoEventManager.Subscribe('GetClientExtension',function(data){

    data.Extensions.push(new SFRecaptchaV3(data));
});

declare let RedNaoEventManager:any;

class SFRecaptchaV3 {
    public StripeOptions:StripeClientOptions;
    public Generator:any;
    public Data:any;
    constructor(data)
    {
        this.Data=null;
        if(typeof data.Generator.client_form_options.Extensions.sf_recaptchav3!='undefined'&&data.Generator.client_form_options.Extensions.sf_recaptchav3.Enabled=='y')
        {
            this.Data=data.Generator.client_form_options.Extensions.sf_recaptchav3;
            let script:HTMLScriptElement=document.createElement('script');
            script.src='https://www.google.com/recaptcha/api.js?render='+data.Generator.client_form_options.Extensions.sf_recaptchav3.PublicKey;
            script.type='text/javascript';
            document.body.appendChild(script);

        }
        /*
        this.Generator=data.Generator;
        if(typeof data.Generator.client_form_options.Extensions.sf_stripe!=='undefined')
        {
            this.StripeOptions=data.Generator.client_form_options.Extensions.sf_stripe;

        }else
            this.StripeOptions={
                Currency:'',
                Condition:'',
                Amount:'',
                ItemName:'',
                Enabled:'n',
                PublicKey:'',
                Email:''
            }*/

    }

    public get IsEnabled(){

        return this.Data!=null&&this.Data.Enabled=='y'
    }


    public BeforeSendingToSmartFormsForm(generator,formValues){
        if(this.IsEnabled) {
            return new Promise((resolve)=>{
                (window as any).grecaptcha.execute(this.Data.PublicKey, {action: 'Submit'}).then((token)=>{
                    formValues._tokenV3=token;

                    resolve(true);
                });

            })
        }
    }


}

RedNaoEventManager.Subscribe('SubmitAction',e=>{

    if(e.Action.Action=='Stripe')
    {
        debugger;
        let stripe=new Stripe(e.Generator.client_form_options.Extensions.sf_stripe.PublicKey);
        stripe.redirectToCheckout({sessionId:e.Action.Value});

    }
})

declare let RedNaoFormula;
declare let Stripe:any;
declare let RedNaoFormulaManagerVar:any;